<template>
  <ValidationObserver id="typeForm" ref="observer" v-slot="{ handleSubmit }">
    <b-tabs
      v-model="tabIndex"
      ref="tabs"
      small
      card
      @activate-tab="tabActivated"
      content-class="px-0"
    >
      <b-tab id="obs0" title="Información Básica" class="px-1">
        <ValidationObserver ref="obs0">
          <basicInformation :variableData="variableData" />
        </ValidationObserver>
      </b-tab>
      <slot>
        <!-- 
          slot for b-tabs variable
          note: remember ref='obs#' for each b-tab
        -->
      </slot>
    </b-tabs>
    <div
      class="row p-1 bg-white with-separator fixed-buttons height-content-footer"
    >
      <div class="col-md-12" v-if="'observer' in $refs">
        <b-button
          v-if="tabIndex < 1 && $refs['observer'].observers.length > 1"
          variant="primary button-footer-1"
          class="float-right"
          pill
          @click="nextStep"
        >
          Siguiente
        </b-button>
        <b-button
          v-if="tabIndex > 0"
          variant="outline-primary button-footer-2"
          pill
          @click="backStep"
        >
          Atrás
        </b-button>
        <b-button
          v-if="tabIndex === 1 || $refs['observer'].observers.length === 1"
          variant="primary button-footer-1"
          class="float-right"
          pill
          @click="handleSubmit(prepareVariable)"
        >
          {{ typeof variableData.id === 'number' ? 'Actualizar' : 'Crear' }}
        </b-button>
      </div>
    </div>
    <!-- <b>generalForm/variable:</b> {{ variableData }}  -->
  </ValidationObserver>
</template>
<script>
import { variablesMethods } from '@state/helpers'
import basicInformation from '@/src/components/variables/basic-information'

export default {
  name: 'generalFormComponent',
  components: {
    basicInformation,
  },
  props: {
    typeForm: { type: String, required: true },
    // variable: { type: Object, required: true },
    variableData: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      lastTabError: null,
      tabIndex: 0,
    }
  },
  methods: {
    ...variablesMethods,

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    async tabActivated(newTabIndex, prevTabIndex, bvEvent) {
      const valid = await this.$refs['observer'].observers[
        prevTabIndex
      ].validate()
      if (!valid && this.lastTabError === null) {
        this.lastTabError = prevTabIndex
        bvEvent.preventDefault()
        this.$generate_noty(
          'error',
          `Hay errores en el formulario ${
            this.$refs['tabs'].registeredTabs[prevTabIndex].title
          }, verifique`
        )
        await this.sleep(400)
        this.tabIndex = prevTabIndex
      } else {
        this.lastTabError = null
      }
    },

    backStep() {
      this.tabIndex--
    },

    nextStep() {
      this.tabIndex++
    },

    prepareVariable() {
      let _ = this
      const promise = this.createVariable(this.variableData)
      return promise
        .then((data) => {
          _.$generate_noty(
            'success',
            `Variable almacenada correctamente`,
            28000
          )
          setTimeout(() => {
            _.$router.push({ name: 'variablesList' })
          }, 2000)
        })
        .catch((error) => {
          _.$generate_noty(
            'error',
            `Se presento un error en la creacion de la variable`
          )
          console.error(
            'Se presento un error en la creacion de la variable:',
            error
          )
        })
    },
  },
  mounted() {
    this.variableData.type = this.typeForm
  },
  watch: {
    variableData: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.label !== '') {
          // this.$refs['observer'].observers[this.tabIndex].validate()
        }
      },
    },
  },
}
</script>
